import { useLocation } from "react-router-dom";
import { getContainerClass } from "../../components/navigation/navigation";
import AnalyticsDashboard from "./AnalyticsDashboard";


const Dashboard = () => {
  const location = useLocation();

  return (
    <>
      <div className={getContainerClass(location.pathname)}>
        {/* <Cover breadcrumb={breadcrumb} page="dashboard" /> */}
        <AnalyticsDashboard />
      </div>
    </>
  );
};

export default Dashboard;
